import { render, staticRenderFns } from "./DatenblattButton.vue?vue&type=template&id=20646424&"
import script from "./DatenblattButton.vue?vue&type=script&lang=js&"
export * from "./DatenblattButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports